import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, toConsumableArray as _toConsumableArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import serialize from 'form-serialize';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { i18n } from '../../i18n/translate.js';
import { FieldGroup } from './FieldGroup.js';
import { MultiRowFieldGroup } from './MultiRowFieldGroup.js';

var MultiRowForm = /*#__PURE__*/function (_React$Component) {
  function MultiRowForm(props) {
    var _this;

    _classCallCheck(this, MultiRowForm);

    _this = _callSuper(this, MultiRowForm, [props]);

    _defineProperty(_this, "onValueChange", function (obj) {
      _this.setState({
        dataValue: obj
      });
    });

    _defineProperty(_this, "onFormValueChange", function (index) {
      return function (obj) {
        _this.setState({
          dataValue: [].concat(_toConsumableArray(_this.state.dataValue.slice(0, index)), [Object.assign(_this.state.dataValue[index], obj)], _toConsumableArray(_this.state.dataValue.slice(index + 1)))
        });
      };
    });

    _defineProperty(_this, "save", function (index) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var form, formState, obj, _formState;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form = _this.bootstrapForms[index];
                formState = _this.state.formState;

                if (!form.checkValidity()) {
                  _context.next = 14;
                  break;
                }

                obj = serialize(form, {
                  hash: true,
                  empty: true
                });
                Object.assign(_this.state.dataValue[index], obj);
                formState[index] = {
                  runValidation: false,
                  isDisabled: true
                };

                _this.setState({
                  formState: formState
                });

                _context.next = 9;
                return _this.props.saveAction(_this.state.dataValue[index], index);

              case 9:
                formState[index] = {
                  runValidation: false,
                  isDisabled: false,
                  isSaved: true
                };

                _this.setState({
                  formState: formState
                });

                return _context.abrupt("return", true);

              case 14:
                _formState = _this.state.formState;
                _formState[index] = {
                  errorMessage: i18n.t('Errors on the form!'),
                  runValidation: true,
                  isDisabled: false
                };

                _this.setState({
                  formState: _formState
                });

                return _context.abrupt("return", false);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    });

    _defineProperty(_this, "wrapWithForm", function (element, data, index) {
      var formState = _this.state.formState[index] || {};
      return /*#__PURE__*/React.createElement(Form, {
        ref: function ref(form) {
          return _this.bootstrapForms[index] = form;
        }
      }, /*#__PURE__*/React.createElement(FieldGroup, {
        onValueChange: _this.onFormValueChange(index),
        scrollContainerId: _this.props.scrollContainerId,
        data: data,
        runValidation: formState.runValidation
      }, element));
    });

    _defineProperty(_this, "getSaveButtonIcon", function (formState) {
      var displaySaveButtonIcon = _this.props.displaySaveButtonIcon;
      if (!displaySaveButtonIcon) return '';
      var saveButtonIcon = 'zmdi zmdi-check-circle';

      if (formState.isDisabled) {
        saveButtonIcon = 'zmdi zmdi-hc-spin zmdi-spinner';
      } else if (formState.isSaved) {
        saveButtonIcon = 'zmdi zmdi-check-circle text-success';
      }

      return saveButtonIcon;
    });

    _defineProperty(_this, "getSaveButton", function (index) {
      var formState = _this.state.formState[index] || {};
      var saveButtonText = _this.props.saveButtonText || i18n.t('Save');
      var saveButtonClass = 'secondary';

      if (formState.isSaved) {
        saveButtonText = _this.props.savedButtonText || i18n.t('Saved');
        saveButtonClass = 'link';
      }

      return {
        action: _this.save(index),
        label: saveButtonText,
        className: saveButtonClass,
        icon: _this.getSaveButtonIcon(formState),
        disabled: formState.isDisabled || !_this.canSaveRow(index)
      };
    });

    _this.state = {
      formState: [],
      dataValue: _toConsumableArray(_this.props.data)
    };
    return _this;
  }

  _inherits(MultiRowForm, _React$Component);

  return _createClass(MultiRowForm, [{
    key: "canSaveRow",
    value: function canSaveRow(index) {
      if (typeof this.props.canSave === 'function') {
        return this.props.canSave(this.state.dataValue[index], index);
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      this.bootstrapForms = [];
      return /*#__PURE__*/React.createElement(MultiRowFieldGroup, _extends({
        addButton: {
          label: this.props.addButtonText || i18n.t('Add')
        },
        className: "multi-row-field-group",
        dataValue: this.state.dataValue,
        onMultiValueChange: this.onValueChange,
        rowWrapper: this.wrapWithForm,
        rowClassName: "col-8",
        rowButtonsClassName: "col-4",
        rowButtons: [this.getSaveButton]
      }, Object.assign({
        deleteButtonText: i18n.t('Delete'),
        saveButtonText: i18n.t('Save'),
        savedButtonText: i18n.t('Saved'),
        addButtonText: i18n.t('Add')
      }, this.props, {
        data: undefined
      })));
    }
  }]);
}(React.Component);

_defineProperty(MultiRowForm, "propTypes", {
  addButtonText: PropTypes.string,
  canSave: PropTypes.func,
  data: PropTypes.array,
  deleteButtonText: PropTypes.string,
  displaySaveButtonIcon: PropTypes.bool,
  scrollContainerId: PropTypes.string,
  saveAction: PropTypes.func,
  saveButtonText: PropTypes.string,
  savedButtonText: PropTypes.string
});

_defineProperty(MultiRowForm, "defaultProps", {
  displaySaveButtonIcon: true,
  idField: 'id'
});

MultiRowForm.displayName = "MultiRowForm";
export { MultiRowForm };